import { eventBus } from '../eventbus';

export function setInitialScripts() {
  //set variable configuration
  const browserLanguage = navigator.language;
  let lang = browserLanguage.includes('it')
    ? 'it'
    : browserLanguage.includes('es')
    ? 'es'
    : 'en';

  const cookiePolicyId = {
    en: 12872322,
    it: 54589597,
    es: 88474275
  };

  const onConsentCallback = function() {
    eventBus.$emit('iubendaConsent');
  };

  window._iub = window._iub || [];
  window._iub.csConfiguration = {
    askConsentAtCookiePolicyUpdate: true,
    ccpaAcknowledgeOnDisplay: true,
    ccpaApplies: true,
    consentOnContinuedBrowsing: false,
    cookiePolicyInOtherWindow: true,
    enableCcpa: true,
    floatingPreferencesButtonDisplay: false,
    invalidateConsentWithoutLog: true,
    lang: lang,
    perPurposeConsent: true,
    siteId: 2614292,
    whitelabel: true,
    cookiePolicyId: cookiePolicyId[lang],
    banner: {
      acceptButtonDisplay: true,
      backgroundOverlay: true,
      closeButtonRejects: true,
      customizeButtonDisplay: true,
      explicitWithdrawal: true,
      listPurposes: true,
      position: 'bottom',
      rejectButtonDisplay: true
    },
    callback: {
      onConsentGiven: onConsentCallback
    }
  };

  //create script function
  const createScriptElement = (type, src, options = {}) => {
    const script = document.createElement('script');
    script.setAttribute('type', type);
    script.setAttribute('src', src);

    // Set additional attributes if provided
    Object.entries(options).forEach(([key, value]) => {
      script.setAttribute(key, value);
    });

    return script;
  };

  //script 1
  const script1 = createScriptElement(
    'text/javascript',
    '//cdn.iubenda.com/cs/ccpa/stub.js'
  );

  //script 2
  const script2 = createScriptElement(
    'text/javascript',
    '//cdn.iubenda.com/cs/iubenda_cs.js',
    {
      charset: 'UTF-8',
      async: true
    }
  );

  //mount scripts
  document.head.appendChild(script1);
  document.head.appendChild(script2);
}
